/**
 *  @swagger
 *  definitions:
 *    RegattaParams:
 *      type: object
 *      properties:
 *        RegionSeasonId:
 *          description: ID of the associated RegionSeason
 *          type: string
 *        ReferenceId:
 *          description: ID of the associated Regatta
 *          type: string
 *        Public:
 *          description: Public of the Regatta
 *          type: boolean
 *        Name:
 *          description: Name of the Regatta
 *          type: string
 *        Slug:
 *          description: Slug of the Regatta
 *          type: string
 *        Content:
 *          description: Content of the Regatta
 *          type: string
 *        Image:
 *          description: Image of the Regatta
 *          type: string
 *        StartDate:
 *          description: Start Date of the Regatta
 *          type: string
 *          format: date-time
 *        EndDate:
 *          description: End Date of the Regatta
 *          type: string
 *          format: date-time
 *        RegistrationStartDate:
 *          description: Registration Start Date of the Regatta
 *          type: string
 *          format: date-time
 *        RegistrationEndDate:
 *          description: Registration End Date of the Regatta
 *          type: string
 *          format: date-time
 *        Location:
 *          description: Location of the Regatta
 *          type: string
 *        GeoLocation:
 *          description: GeoLocation of the Regatta
 *          type: string
 *        GeoLocationLat:
 *          description: GeoLocationLat of the Regatta
 *          type: integer
 *        GeoLocationLng:
 *          description: GeoLocationLng of the Regatta
 *          type: integer
 *        OrganizerName:
 *          description: Organizer Name of the Regatta
 *          type: string
 *        OrganizerEmail:
 *          description: Organizer Email of the Regatta
 *          type: string
 *        OrganizerContact:
 *          description: Organizer Contact of the Regatta
 *          type: string
 *        Consent:
 *          description: Consent of the Regatta
 *          type: string
 *        Lock:
 *          description: Lock of the Regatta
 *          type: boolean
 *        Canceled:
 *          description: Canceled of the Regatta
 *          type: boolean
 *        PageEnabled:
 *          description: Page Enabled of the Regatta
 *          type: boolean
 *        ListEnabled:
 *          description: List Enabled of the Regatta
 *          type: boolean
 *        BowNoEnabled:
 *          description: Bow No Enabled of the Regatta
 *          type: boolean
 *        GroupChangeEnabled:
 *          description: Page Enabled of the Regatta
 *          type: boolean
 *        PreventDuplicateRegistrationNo:
 *          description: Prevent Duplicate Registration No of the Regatta
 *          type: boolean
 *        RegistrationEnabled:
 *          description: Registration Enabled of the Regatta
 *          type: boolean
 *        SubmitProtestEnabled:
 *          description: Submit Protest Enabled of the Regatta
 *          type: boolean
 *        RegistrationTshirtField:
 *          description: Registration Tshirt Field of the Regatta
 *          type: boolean
 *        RegistrationBirthdateField:
 *          description: Registration Birthdate Field of the Regatta
 *          type: boolean
 *        RegistrationEmailField:
 *          description: Registration Email Field of the Regatta
 *          type: boolean
 *        RegistrationWeightField:
 *          description: Registration Weight Field of the Regatta
 *          type: boolean
 *        RegistrationHarborField:
 *          description: Registration Harbor Field of the Regatta
 *          type: boolean
 *        RegistrationClubField:
 *          description: Registration Club Field of the Regatta
 *          type: boolean
 *        RegistrationMembershipField:
 *          description: Registration Membership Field of the Regatta
 *          type: boolean
 *        RegistrationContent:
 *          description: Content of the Regatta
 *          type: string
 *        SailNoEnabled:
 *          description: SailNo Enabled of the Regatta
 *          type: boolean
 *        CountryEnabled:
 *          description: Country Enabled of the Regatta
 *          type: boolean
 *        Invoice:
 *          description: Invoice of the Regatta
 *          type: string
 *        InvoiceAdminId:
 *          description: ID of the associated Invoice Admin
 *          type: string
 *
 *  @swagger
 *  definitions:
 *    RegattaCreateParams:
 *      allOf:
 *        - $ref: '#/definitions/RegattaParams'
 *        - type: object
 *          required:
 *            - RegionSeasonId
 *            - Public
 *            - Name
 *            - StartDate
 *            - EndDate
 *            - Location
 *            - OrganizerEmail
 *            - Lock
 *            - Canceled
 *            - PageEnabled
 *            - ListEnabled
 *            - BowNoEnabled
 *            - GroupChangeEnabled
 *            - PreventDuplicateRegistrationNo
 *            - RegistrationEnabled
 *            - SubmitProtestEnabled
 *            - RegistrationTshirtField
 *            - RegistrationEmailField
 *            - RegistrationBirthdateField
 *            - RegistrationWeightField
 *            - RegistrationHarborField
 *            - RegistrationClubField
 *            - RegistrationMembershipField
 *
 *  @swagger
 *  definitions:
 *    RegattaQueryParams:
 *      allOf:
 *        - type: object
 *          properties:
 *            id:
 *              description: ID of the Regatta
 *              type: string
 *        - $ref: '#/definitions/RegattaParams'
 *
 *  @swagger
 *  definitions:
 *    RegattaUpdateParams:
 *      allOf:
 *        - $ref: '#/definitions/RegattaQueryParams'
 *        - type: object
 *          required:
 *            - id
 *
 *  @swagger
 *  definitions:
 *    Regatta:
 *      allOf:
 *        - $ref: '#/definitions/RegattaCreateParams'
 *        - $ref: '#/definitions/RegattaUpdateParams'
 *        - $ref: '#/definitions/Timestamps'
 *
 *  @swagger
 *  components:
 *    schemas:
 *      Regatta:
 *        allOf:
 *          - $ref: '#/definitions/Regatta'
 *          - type: object
 *            properties:
 *              RegionSeason:
 *                description: RegionSeason of the Regatta
 *                $ref: '#/components/schemas/RegionSeason'
 *              Reference:
 *                description: Reference of the Regatta
 *                $ref: '#/components/schemas/Regatta'
 *              RegattaPayment:
 *                description: RegattaPayment of the Regatta
 *                $ref: '#/components/schemas/RegattaPayment'
 *              RegattaInvoiceAdmin:
 *                description: Invoice Admin of the Regatta
 *                $ref: '#/components/schemas/Admin'
 *              RegattaGroups:
 *                description: RegattaGroups of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaGroup'
 *              RegattaChecks:
 *                description: RegattaChecks of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaCheck'
 *              RegattaContacts:
 *                description: RegattaContacts of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaContact'
 *              RegattaCourses:
 *                description: RegattaCourses of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaCourse'
 *              RegattaDocuments:
 *                description: RegattaDocuments of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaDocument'
 *              RegattaEntries:
 *                description: RegattaEntries of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaEntry'
 *              RegattaGalleries:
 *                description: RegattaGalleries of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaGallery'
 *              RegattaMessages:
 *                description: RegattaMessages of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaMessage'
 *              RegattaNotifications:
 *                description: RegattaNotifications of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaNotification'
 *              RegattaProtests:
 *                description: RegattaProtests of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaProtest'
 *              RegattaRequirements:
 *                description: RegattaRequirements of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaRequirement'
 *              RegattaSchedules:
 *                description: RegattaSchedules of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaSchedule'
 *              RegattaSponsors:
 *                description: RegattaSponsors of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaSponsor'
 *              RegattaTrackEvents:
 *                description: RegattaTrackEvents of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaTrackEvent'
 *              RegattaResultTables:
 *                description: RegattaResultTables of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaResultTable'
 *              RegattaResultOveralls:
 *                description: RegattaResultOveralls of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaResultOverall'
 *              RegattaAdminRequests:
 *                description: RegattaAdminRequests of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaAdminRequest'
 *              Advertisements:
 *                description: Advertisements of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/Advertisement'
 *              Reference:
 *                description: Reference of the Regatta
 *                $ref: '#/components/schemas/Regatta'
 *              Groups:
 *                description: Groups of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/Group'
 *              Championships:
 *                description: Championships of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/Championship'
 *              Admins:
 *                description: Admins of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/Admin'
 *              RegattaSubscriptions:
 *                description: RegattaSubscriptions of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaSubscription'
 *              RegattaDays:
 *                description: RegattaDays of the Regatta
 *                type: array
 *                items:
 *                  $ref: '#/components/schemas/RegattaDay'
 *          - type: object
 *            properties:
 *              Status:
 *                description: Status of the Regatta
 *                $ref: '#/components/enums/RegattaStatus'
 *              RegistrationStatus:
 *                description: Registration Status of the Regatta
 *                $ref: '#/components/enums/RegattaRegistrationStatus'
 */

// Helpers
import {
  validateSlug,
} from '../helpers';

// Enums
import {
  RegattaRegistrationStatus,
  RegattaStatus,
} from '../enums';

// Types
import type {
  $Model,
  $ModelClass,
  $ModelClasses,
} from '.';
import type {
  $Field,
} from '../types';

type $VirtualParams = {
  RegistrationStatus: RegattaRegistrationStatus;
  Status: RegattaStatus;
};

export type $RelationIds = {
  InvoiceAdminId: null | string;
  ReferenceId: null | string;
  RegionSeasonId: string;
};

export type $Params = {
  BowNoEnabled: boolean;
  Canceled: boolean;
  Consent: null | string;
  Content: null | string;
  CountryEnabled: boolean;
  EndDate: Date;
  GeoLocation: null | string;
  GeoLocationLat: null | number;
  GeoLocationLng: null | number;
  GroupChangeEnabled: boolean;
  Highlight: boolean;
  Image: null | string;
  Invoice: null | string;
  ListEnabled: boolean;
  Location: string;
  Lock: boolean;
  Name: string;
  OrganizerContact: null | string;
  OrganizerEmail: string;
  OrganizerName: null | string;
  PageEnabled: boolean;
  PreventDuplicateRegistrationNo: boolean;
  Public: boolean;
  RegistrationBirthdateField: boolean;
  RegistrationClubField: boolean;
  RegistrationContent: null | string;
  RegistrationEmailField: boolean;
  RegistrationEnabled: boolean;
  RegistrationEndDate?: Date | null;
  RegistrationHarborField: boolean;
  RegistrationMembershipField: boolean;
  RegistrationStartDate?: Date | null;
  RegistrationTshirtField: boolean;
  RegistrationWeightField: boolean;
  SailNoEnabled: boolean;
  Slug: null | string;
  StartDate: Date;
  SubmitProtestEnabled: boolean;
};

export type $CreateParams = $Params & $RelationIds;

export type $UpdateParams = {
  id: string;
} & Partial<$CreateParams>;

export type $UpsertParams = $CreateParams & {
  id?: string;
};

export type $QueryParams = {
  id?: null | string;
} & Partial<$CreateParams>;

export type $Associations = {
  Admins?: Array<$Model<'Admin'>>;
  Advertisements?: Array<$Model<'Advertisement'>>;
  Championships?: Array<$Model<'Championship'>>;
  Groups?: Array<$Model<'Group'>>;
  InvoiceAdmin?: $Model<'Admin'>;
  Reference?: $Model<'Regatta'>;
  RegattaAdminRequests?: Array<$Model<'RegattaAdminRequest'>>;
  RegattaChecks?: Array<$Model<'RegattaCheck'>>;
  RegattaContacts?: Array<$Model<'RegattaContact'>>;
  RegattaDays?: Array<$Model<'RegattaDay'>>;
  RegattaDocuments?: Array<$Model<'RegattaDocument'>>;
  RegattaEntries?: Array<$Model<'RegattaEntry'>>;
  RegattaGalleries?: Array<$Model<'RegattaGallery'>>;
  RegattaGroups?: Array<$Model<'RegattaGroup'>>;
  RegattaMessages?: Array<$Model<'RegattaMessage'>>;
  RegattaNotifications?: Array<$Model<'RegattaNotification'>>;
  RegattaPayment?: $Model<'RegattaPayment'>;
  RegattaProtests?: Array<$Model<'RegattaProtest'>>;
  RegattaRequirements?: Array<$Model<'RegattaRequirement'>>;
  RegattaResultOveralls?: Array<$Model<'RegattaResultOverall'>>;
  RegattaResultTables?: Array<$Model<'RegattaResultTable'>>;
  RegattaSchedules?: Array<$Model<'RegattaSchedule'>>;
  RegattaSponsors?: Array<$Model<'RegattaSponsor'>>;
  RegattaSubscriptions?: Array<$Model<'RegattaSubscription'>>;
  RegattaTrackEvents?: Array<$Model<'RegattaTrackEvent'>>;
  RegionSeason?: $Model<'RegionSeason'>;
};

export type $ModelParams = $Associations & $CreateParams & $VirtualParams & {
  id: string;
};

type $Fields = $Params & $VirtualParams & {
  id: string;
};

const fields = (
  Sequelize,
): Record<keyof $Fields, $Field> => ({
  BowNoEnabled: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  Canceled: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  Consent: {
    allowNull: true,
    type: Sequelize.STRING,
    validate: {
      notEmpty: true,
    },
  },
  Content: {
    allowNull: true,
    type: Sequelize.TEXT,
    validate: {
      notEmpty: true,
    },
  },
  CountryEnabled: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  EndDate: {
    allowNull: false,
    type: Sequelize.DATE,
    validate: {
      notEmpty: true,
    },
  },
  GeoLocation: {
    allowNull: true,
    type: Sequelize.STRING,
    validate: {
      notEmpty: true,
    },
  },
  GeoLocationLat: {
    allowNull: true,
    type: Sequelize.DOUBLE(
      10,
      6,
    ),
  },
  GeoLocationLng: {
    allowNull: true,
    type: Sequelize.DOUBLE(
      10,
      6,
    ),
  },
  GroupChangeEnabled: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  Highlight: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  id: {
    allowNull: false,
    defaultValue: Sequelize.UUIDV4,
    primaryKey: true,
    type: Sequelize.UUID,
    unique: true,
  },
  Image: {
    allowNull: true,
    type: Sequelize.STRING,
    validate: {
      notEmpty: true,
    },
  },
  Invoice: {
    allowNull: true,
    type: Sequelize.STRING,
    validate: {
      notEmpty: true,
    },
  },
  ListEnabled: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  Location: {
    allowNull: false,
    type: Sequelize.STRING,
    validate: {
      notEmpty: true,
    },
  },
  Lock: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  Name: {
    allowNull: false,
    type: Sequelize.STRING,
    validate: {
      notEmpty: true,
    },
  },
  OrganizerContact: {
    allowNull: true,
    type: Sequelize.STRING,
    validate: {
      notEmpty: true,
    },
  },
  OrganizerEmail: {
    allowNull: false,
    type: Sequelize.STRING,
    validate: {
      isEmail: true,
      notEmpty: true,
    },
  },
  OrganizerName: {
    allowNull: true,
    type: Sequelize.STRING,
    validate: {
      notEmpty: true,
    },
  },
  PageEnabled: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  PreventDuplicateRegistrationNo: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  Public: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  RegistrationBirthdateField: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  RegistrationClubField: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  RegistrationContent: {
    allowNull: true,
    type: Sequelize.TEXT,
    validate: {
      notEmpty: true,
    },
  },
  RegistrationEmailField: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  RegistrationEnabled: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  RegistrationEndDate: {
    allowNull: true,
    type: Sequelize.DATE,
    validate: {
      notEmpty: true,
    },
  },
  RegistrationHarborField: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  RegistrationMembershipField: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  RegistrationStartDate: {
    allowNull: true,
    type: Sequelize.DATE,
    validate: {
      notEmpty: true,
    },
  },
  RegistrationStatus: {
    /* eslint-disable-next-line complexity */
    get(): RegattaRegistrationStatus {
      const RegistrationEnabled = this.get('RegistrationEnabled') as boolean;
      const Canceled = this.get('Canceled') as boolean;
      const now: number = Date.now();

      if (RegistrationEnabled === true && Canceled === false) {
        const RegistrationStartDate = this.get('RegistrationStartDate') as null | number;
        const RegistrationEndDate = this.get('RegistrationEndDate') as null | number;
        const StartDate = this.get('StartDate') as number;

        if (RegistrationStartDate !== null && RegistrationStartDate > now) {
          return RegattaRegistrationStatus.upcoming;
        }

        if (RegistrationEndDate !== null) {
          if (RegistrationEndDate < now) {
            return RegattaRegistrationStatus.ended;
          }
        } else if (StartDate < now) {
          return RegattaRegistrationStatus.ended;
        }

        return RegattaRegistrationStatus.ongoing;
      }

      return RegattaRegistrationStatus.off;
    },

    type: new Sequelize.VIRTUAL(
      Sequelize.ENUM(...Object.values(RegattaRegistrationStatus)),
      ['Canceled', 'RegistrationEnabled', 'RegistrationEndDate', 'RegistrationStartDate', 'StartDate'],
    ),
  },
  RegistrationTshirtField: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  RegistrationWeightField: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  SailNoEnabled: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
  Slug: {
    allowNull: true,
    type: Sequelize.STRING,
    validate: {
      notEmpty: true,
    },
  },
  StartDate: {
    allowNull: false,
    type: Sequelize.DATE,
    validate: {
      notEmpty: true,
    },
  },
  Status: {
    /* eslint-disable-next-line complexity */
    get(): RegattaStatus {
      const StartDate = this.get('StartDate') as number;
      const EndDate = this.get('EndDate') as number;
      const Canceled = this.get('Canceled') as boolean;
      const createdAt = this.get('createdAt') as number;

      const now: number = Date.now();

      if (Canceled === true) {
        return RegattaStatus.canceled;
      }

      if (EndDate < now) {
        return RegattaStatus.ended;
      }

      if (StartDate < now) {
        return RegattaStatus.ongoing;
      }

      const weekMs: number = 7 * 24 * 60 * 60 * 1000;

      if (createdAt + weekMs > now) {
        return RegattaStatus.new;
      }

      return RegattaStatus.upcoming;
    },

    type: new Sequelize.VIRTUAL(
      Sequelize.ENUM(...Object.values(RegattaStatus)),
      ['StartDate', 'EndDate', 'Canceled', 'createdAt'],
    ),
  },
  SubmitProtestEnabled: {
    allowNull: false,
    defaultValue: false,
    type: Sequelize.BOOLEAN,
  },
});

export default ((
  Sequelize,
  stack,
): $ModelClass<'Regatta'> => {
  const Regatta = stack.define(
    'Regatta',
    fields(Sequelize),
    {
      tableName: 'Regattas',
    },
  );

  Regatta.associate = (models: $ModelClasses) => {
    models.Regatta.belongsTo(
      models.RegionSeason,
      {
        as: 'RegionSeason',
        foreignKey: 'RegionSeasonId',
      },
    );
    models.Regatta.belongsTo(
      models.Regatta,
      {
        as: 'InvoiceAdmin',
        constraints: false,
        foreignKey: 'InvoiceAdminId',
      },
    );
    models.Regatta.belongsTo(
      models.Regatta,
      {
        as: 'Reference',
        constraints: false,
        foreignKey: 'ReferenceId',
      },
    );
    models.Regatta.hasOne(
      models.RegattaPayment,
      {
        as: 'RegattaPayment',
        constraints: false,
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaCheck,
      {
        as: 'RegattaChecks',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaContact,
      {
        as: 'RegattaContacts',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaCourse,
      {
        as: 'RegattaCourses',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaDocument,
      {
        as: 'RegattaDocuments',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaEntry,
      {
        as: 'RegattaEntries',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaGallery,
      {
        as: 'RegattaGalleries',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaMessage,
      {
        as: 'RegattaMessages',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaNotification,
      {
        as: 'RegattaNotifications',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaProtest,
      {
        as: 'RegattaProtests',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaRequirement,
      {
        as: 'RegattaRequirements',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaSchedule,
      {
        as: 'RegattaSchedules',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaSponsor,
      {
        as: 'RegattaSponsors',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaTrackEvent,
      {
        as: 'RegattaTrackEvents',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaResultTable,
      {
        as: 'RegattaResultTables',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaResultOverall,
      {
        as: 'RegattaResultOveralls',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.Advertisement,
      {
        as: 'Advertisements',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaGroup,
      {
        as: 'RegattaGroups',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaAdminRequest,
      {
        as: 'RegattaAdminRequests',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaSubscription,
      {
        as: 'RegattaSubscriptions',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.hasMany(
      models.RegattaDay,
      {
        as: 'RegattaDays',
        foreignKey: 'RegattaId',
      },
    );
    models.Regatta.belongsToMany<'Group', 'RegattaGroup'>(
      models.Group,
      {
        as: 'Groups',
        foreignKey: 'RegattaId',
        otherKey: 'GroupId',
        through: models.RegattaGroup,
      },
    );
    models.Regatta.belongsToMany(
      models.Championship,
      {
        as: 'Championships',
        foreignKey: 'RegattaId',
        otherKey: 'ChampionshipId',
        through: models.ChampionshipRegatta,
      },
    );
    models.Regatta.belongsToMany(
      models.Admin,
      {
        as: 'Admins',
        foreignKey: 'RegattaId',
        otherKey: 'AdminId',
        through: models.RegattaAdmin,
      },
    );
  };

  Regatta.hooks = (models: $ModelClasses) => {
    Regatta.addHook(
      'beforeValidate',
      async (regatta: $Model<'Regatta'>) => {
        if (typeof regatta.Slug !== 'undefined') {
          let currentValue: null | string = null;

          if (regatta.id) {
            currentValue = await Regatta.findByPk(regatta.id).Slug;
          }

          /* eslint-disable-next-line no-param-reassign,require-atomic-updates */
          regatta.Slug = await validateSlug({
            currentValue,
            models,
            newValue: regatta.Slug,
            RegionSeasonId: regatta.RegionSeasonId,
          });
        }
      },
    );
  };

  Regatta.addScope(
    'defaultScope',
    {
      order: [['StartDate', 'ASC']],
    },
  );

  return Regatta;
});
